import React, { useState } from "react"
import {NavLink } from 'react-router-dom';
import image from  '../assets/i29.png'
import Icon from "./Element/Icon"
import imageUrl from  '../assets/logo.png'

import Icons from "./Element/Icons"



export const Conctact = () => {
  

const handleSubmit = (e) => {
  e.preventDefault();
};
    return(

      <>
     <header className="App">
    
    
    <nav className="navbar-nav navbar navbar-expand-lg navbar-light bg-light ">   
  
     
       
       <NavLink className="navbar-brand" href="/">
         <img
           className="logo-ifc"
           src={image}
           alt="logo ifc"
          
           width='60px'
         />
       </NavLink >
       
     
       <ul className="nav navbar-nav">
         <li className="">
           <NavLink to="/accueil">Accueil</NavLink>
         </li>
         <li className="">
           <NavLink to="/Examen">Faqs</NavLink>
         </li>
         <li className="">
           <NavLink to="/Contact">Contact</NavLink>
         </li>
     
         <li className="">
           <NavLink to="/"></NavLink>
         </li>
         <li className="">
           <NavLink to="/espCandidat">EspaceCandidat</NavLink>
         </li>
       </ul>
     
   
 </nav>
 </header>
      <div className="contact-form">
          <div className="imageflottante">
            <img
              src={image} style={{
                width: '500px',
                height: '300px',}}
              alt="examen TEF-Canada IFC."
              className="img-responsive"
            />
          </div>
          <h2 style={{ textAlign: 'center', color: 'blue', fontWeight: 'bold' }}> <a href="https://wa.me/686876873" style={{ color: 'inherit', textDecoration: 'none' }}>
            Contactez-nous
          </a></h2>
           
            <a href="/" > <Icon name="precedent" /></a>
    <a href="/Examen" ><Icon name="question" /></a>
    <a href="/faq" > <Icon name="register" /></a>
    <a href="/accueil" > <Icon name="home" /></a>
            </div>
            <footer className="footer secondary-footer"  style={{ backgroundColor: '#928490 ' }}>
      <div className="container">
         <div class="row">
         <div
         className="col-md-12 col-sm-12 col-xs-12"
         style={{ textAlign: "center" }}
       >
               <p>Objectif Canada</p>
            </div>
            
         </div>
        
    <a href="https://www.facebook.com/sandra.magne.7161" target="_blank" rel="noopener noreferrer"> <Icons name="face" /></a>
    <a href="https://wa.me/682336519" ><Icons name="what" /></a>
    <a href="https://www.instagram.com/fotsingivana" > <Icons name="insta" /></a>
    <a href="https://www.tiktok.com/@ivanasandra4" > <Icons name="tik" /></a>
      </div>
      
   </footer>
            </>
    )
    }